import React,{useState,useEffect,useRef} from "react";

  import { useRouteMatch,Switch, Route ,Link} from "react-router-dom";
import { useHistory,} from "react-router-dom";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,
  GripHorizontal,
  SendToBack} from 'lucide-react';
import ContentMenuCard from "../ContentMenuCard";
import LoadingButton from "../../../Loading/LoadingButton";

import contentfolder from "../../../contentImgs/folder.png";
import contentNewfolder from "../../../contentImgs/blended-learning.png";
import Snackbar from "../../../../Snackbar";
import { createNewFolder, getAllFoldersByApp } from "../../../../store/actions/CreateContent/FolderAPI/FolderAPIs";
import Loading from "../../../Loading/Loading";
import { createNewMilestone } from "../../../../store/actions/CreateContent/OrganizeAPI/SubCoursesAPIs";
import { createNewSection } from "../../../../store/actions/CreateContent/FolderAPI/SectionAPI";
import AddmakeFreeSection from "./AddSkillSection";
import { addEntityToAnyEntity } from "../../../../store/actions/CreateContent/FolderAPI/ChapterAPI";
import AddHighlightsSection from "./AddHighlightsSection";
import AddHighlightsChapter from "./AddHighlightsChapter";
import ToggleSmall from "../../../UI/ToggleSmall";
import Toggle from "../../../UI/Toggle";
import AddToFolderButton from "../AddToFolderButton";
const CreateFolderInChapterPopup =({sendBackItem,parentEntityType,parentEntityID,menuOrder,setClosePopUp})=>{

     const dispatch = useDispatch();
     
        const [snackbarVisible, setSnackbarVisible] = useState(false);
        const [snackbarColor, setSnackbarColor] = useState("#958FDA");
        const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
      
      const showSnackbar = () => {
        setSnackbarVisible(true);
      };
     
      const hideSnackbar = () => {
        setSnackbarVisible(false);
      };
  const [folderItem ,setFolderID] =useState();
      const [chapterMenuOrder ,setChapterMenuOrder] =useState(menuOrder);
       
     const [FolderLook ,setFolderLook] =useState("")
           
           
        const [loader , setLoader] =useState({status:false});
      
       const [animate, setAnimate] = useState(false);
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
        



      
       const token = useSelector((state)=>state?.course?.course?.token);
       const currentToken = useSelector((state)=>state?.user?.user?.token);
       const user_email = useSelector((state)=>state?.user?.user?.user_email
      );
      
      const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
      
      const courseData = useSelector((state)=>state?.course?.course);
      
      const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
       const appId = useSelector((state)=>state?.app?.app?.ID);
                            const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
          const [visibility,setVisibility] =useState("public");
                     const [orderBy,setOrderBy] =useState("ASC");
                     const [itemArr, setItemArr] = useState([]);
                     const [itemReorderArr, setItemReorderArr] = useState([]);
                     const [itemId, setItemId] = useState("");
                     const [deleteFolderPopUp, setDeleteFolderPopUp] = useState(false);
                     const [itemArrLoading, setItemArrLoading] = useState([{},{},{},{}]);
                     const [openContentInFolder, setOpenContentInFolder] = useState("");
                     const [openQuizPopUpContent, setopenQuizPopUpContent] = useState("");
                     const [parentFolderItem, setParentFolderItem] = useState({});
                    
       useEffect(() => {
         // Trigger the animation after a delay (e.g., 500ms)
         const timer = setTimeout(() => {
          setAnimate(true);  
        }, 100);
      
         return () => clearTimeout(timer); // Cleanup on unmount
       }, []);
      useEffect(()=>{
        // setCourseTitleData();
        fireGetAllCoursesByApp();
      },[])
      
      

        const fireGetAllCoursesByApp=()=>{
                setItemArr([])
                      
              
                      
              
                setItemArrLoading([{},{},{},{}])
              // Popup When Course is not selected
               
              setLoader({status:true});
                  // console.log({
                    //   token:AppToken,courseId:postIdCourse ,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",appToken:AppToken,
                    //   });
                    const apiData = dispatch(getAllFoldersByApp({
                      token:AppToken,courseId:postIdCourse ,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
                      appToken:AppToken,visibility:visibility,orderBy:orderBy,appId:appId
                      }));
                    /* get response as Promise   */
                    apiData.then(response => {
                      // console.log(response)
              
                      if(response){
                       
                        if(response){
                      setResponseMessage(response?.message);
                      setSnackbarColor("rgba(144, 202, 249,1)");
                    
                      if(response?.folders)  {setItemArr(response?.folders); 
              
                        const reorderArray = response?.folders.map(item => ({
                          ID: item.ID,
                          menuOrder: item.menuOrder
                      }));
                      setItemReorderArr(reorderArray);
                      //  console.log(reorderArray)
                      
                      }else{setItemArr([]);};
                      setItemArrLoading([]);
                  setLoader({status:false});
                  
                  // setSnackbarVisible(true);
                  setTimeout(()=>{
                    
                    setSnackbarVisible(false);
                  },1000)
                     }else{
                  //     setResponseMessage("Something Went Wrong...");
                        
                  //     setSnackbarColor("#958FDA");
                  //   //  selectCoursePopUp(true);
                      
                       
                  // setLoader({status:false});
                  // setItemArrLoading([{},{},{},{}]);
                  setSnackbarVisible(true);
                  setTimeout(()=>{
                    
                    setSnackbarVisible(false);
                   
                     
                  },3000)
                     }
                        
                      // dispatch({
                      //   type: "UPDATE_APP_TOKEN",
                        
                      //   payload:response?.course?.AppToken
                      // });  
                    //  console.log(response?.course);
                   
                     // 
                     if(response?.logout){
                      // pop up response?.logoutInfo
                      //console.log(response?.logoutInfo)
                  
                      setResponseMessage("You are Logged Out!!!");
                        
                      setSnackbarColor("#958FDA");
                      
                       
                  setLoader({status:false});
                  
                  setTimeout(()=>{
                    
                    setSnackbarVisible(false);
                   
                     
                  },3000)
                      setTimeout(()=>{
                        dispatch({type:"LOGOUT"});
                  
                      },3000)
                      
                    }
                  /* resetting Login input Fields */
                  
                      }else{
                        setResponseMessage("Something Went Wrong...");
                        
                        setSnackbarColor("#958FDA");
                      
                       setItemArrLoading([{},{},{},{}]);
                         
                    setTimeout(()=>{
                      
                     
                       
                    },3000)    }
                  
                    }).catch(error => {
                   
                      //popup of error Info
                      setResponseMessage("Something Went Wrong...");
                        
                      setSnackbarColor("#958FDA");
                    
                       
                  setTimeout(()=>{
                    
                    setSnackbarVisible(false);
                   
                     
                  },3000)
                      console.error(error);
                    });
               }

     
const handleUpdateFolderInChapter=(val)=>{
    
     setLoader({status:true});

      const apiData = dispatch(addEntityToAnyEntity({
        visibility:"public",parentEntityType:parentEntityType,parentEntityId:parentEntityID,
        childEntityType:"Folder",childEntityId:folderItem?.ID,editType:"",
      courseId:postIdCourse ,userEmail:user_email?user_email:null,
      currentToken:currentToken?currentToken:null,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,
      menuOrder:chapterMenuOrder}));
    /* get response as Promise   */
    apiData.then(response => {
      if(response){
      
        if(response){
      setResponseMessage(response?.message);
      setSnackbarColor("rgba(144, 202, 249,1)");
    
       sendBackItem(folderItem);
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setClosePopUp(false);
  },1000)
     }else{
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
     }
        
     
     if(response?.logout){
     
      setResponseMessage("You are Logged Out!!!");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      setTimeout(()=>{
        dispatch({type:"LOGOUT"});
  
      },3000)
      
    }
  /* resetting Login input Fields */
  
      }else{
        setResponseMessage("Something Went Wrong...");
        
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)    }
  
    }).catch(error => {
   
      //popup of error Info
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      console.error(error);
    });
   
    }

 const flattenedData = itemArr!=[]?Object.values(itemArr):'';

        const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):'';


    return (<>
    
   {/* {<Loading  Load={loader?.status}/>} */}
     {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}
    {FolderLook==""?<div className="" style={{alignContent:"center",textAlign:"center",marginTop:"0px",
     
     transition: 'transform 2s ease, opacity 1s ease',
   }}><div onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}  style={{width:"40px",height:"40px",cursor:"pointer",
           borderRadius:"50%",float:"right",margin:"10px",
         background:"#958FDA",zIndex:999999}} onClick={()=>setClosePopUp(false)}   >
           <X  style={{padding:"9px",}} color="#fff" size={22}/></div> 
    
    
     <div className="userInfoLinerName"> <h1>Showing All <span className="coloredTextV1" > Folders</span></h1></div>
    <div align="center" className="" style={{position:"absolute", top:"70px",bottom:"98px",right:"10px",left:"10px",
            overflowY:"auto"}}>
        
        
        <div className="FolderAdderOuter">
   
{flattenedData?flattenedData?.map((item, index) => 
        (<div  className="FolderAdderOuterInner" index={index} key={item?.ID} 
            onClick={()=>{
                setFolderID(item) ;
            }}>
            <div >
<div  className="" style={{marginTop:"0px",paddingLeft:"10px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
<div className="">
<img     src={contentfolder} 
        alt="selected Img"
   style={{cursor:"pointer",width:"80px",height:"80px"
    
   }}/> </div><div className=""> <div className="themeNone "
 style={{fontSize:"25px",color:"#111",fontWeight:"700"}}> 
  {item?.Name}
 
      </div></div>
  </div> </div>  
  
  </div>)):""}

      {flattenedDataLoading?.map((item, index) => 
        (<div  index={index} key={index} 
          >
<div  className="FolderAdderOuterInner" style={{margin:"10px",minHeight:"70px",marginTop:"10px",padding:"10px",background:"#ffffff"}}>
        <div  style={{marginTop:"0px",paddingLeft:"10px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
     <div className="text-linetw "  style={{marginTop:"5px",marginRight:"10px",height:"57px",width:"54px",paddingLeft:"10px",padding:"5px"}}>
    
    </div> <div  className="text-linetw" style={{marginTop:"5px",height:"57px",width:"74%",paddingLeft:"10px",padding:"5px"}}>
</div></div>
     </div>  </div>)) }

     </div>

  {flattenedDataLoading?.length==0?flattenedData?.length?"": <div align="center"style={{margin:"15px",padding:"10px",borderRadius:"15px",background:"rgba(255,114,94,0.1)"}}><h3 style={{"textAlign":"center",
       
      }}> Opps... <span className="coloredTextV1">No Folders Found !!!</span></h3>
      <h5>
         </h5>
      </div>:""}
    
    </div>
    {folderItem?.ID?<>
    <div   onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{zIndex:99,cursor:"pointer"}} onClick={()=>setFolderID("")} className="appDesignPopUpOpacity"> </div>
        <div   className="AreYouSurePopUp" style={{height:"400px",borderRadius: '20px'}}> 
        <h2 align="center" > Are You Sure -You want To  Add This   <span className="coloredTextV1" > Folder ?</span> </h2>
      
 
<div className="bookmarkListScroll" style={{overflowY:"auto",height:"300px",overflowX:"hidden",position:"relative"}}>
    <div  className="FolderAdderOuterInner"  style={{background:"transparent",border:"2px dashed rgba(144, 202, 249,1) "}}
           >
            <div >
<div  className="" style={{marginTop:"0px",paddingLeft:"10px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
<div className="">
<img     src={contentfolder} 
        alt="selected Img"
   style={{cursor:"pointer",width:"80px",height:"80px"
    
   }}/> </div><div className=""> <div className="themeNone "
 style={{fontSize:"25px",color:"#111",fontWeight:"700"}}> 
  {folderItem?.Name}
 
      </div></div>
  </div> </div>  
  
  </div>
    <div align="center" className="" style={{position:"absolute",left:"0px",right:"0px",bottom:"30px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"0px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}><button onMouseEnter={handleMouseEnter} 
  onMouseLeave={handleMouseLeave} onClick={()=>{setFolderID("")}}  
    className=" courseInfobtnshorizontal"  style={{background:"#666",border:"3px solid #666",color:"#fff",fontSize:"16px"}} type="submit"
 > Cancel </button>

<button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{
    handleUpdateFolderInChapter('editChapter')
  
  }}   style={{width:"140px",height:"55px",background:"rgba(144, 202, 249,0.51)",color:"#333333"}}
  className=" rightButtonSetItBlue"  type="submit"
 > {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Add Folder"} </button>

</div> 
</div></div></>:""}
 </div>
 
 :""}
       </>)
}
export default CreateFolderInChapterPopup;

